import * as bigInt from 'big-integer';
import { ElementRect } from '../mcrc-api';
export type BigInteger = bigInt.BigInteger;

export class MathHelpers {
    
    static easeInOutCubic(t: number, start: number, change: number, duration: number): number {
        t /= duration / 2;
        if (t < 1) return change / 2 * t * t * t + start;
        t -= 2;
        return change / 2 * (t * t * t + 2) + start;
    };

    static easeOutCubic(t: number, start: number, change: number, duration: number): number {
        t /= duration;
        t--;
        return change * (t * t * t + 1) + start;
    };

    static toSizeString(bigint: BigInteger): string {
        const oneKB = bigInt("1024");
        const oneMB = bigInt("1048576");
        const oneGB = bigInt("1073741824");
        let returnValue: string;
        if (bigint.compare(oneKB) < 0) { // less than 1KB
            const value = bigint.toJSNumber();
            returnValue = value.toLocaleString() + " bytes";
        } else if (bigint.compare(oneMB) < 0) { // less than 1MB
            const value = bigint.divide(oneKB).toJSNumber();
            returnValue = value.toLocaleString() + " KB";
        } else if (bigint.compare(oneGB) < 0) { // less than 1GB
            const value = bigint.divide(oneMB).toJSNumber();
            returnValue = value.toLocaleString() + " MB";
        } else {
            const value = (bigint.divide(oneMB).toJSNumber() / 1024).toPrecision(3);
            returnValue = value.toLocaleString() + " GB";
        }
        return returnValue;
    };

    static getProjectionOffset(context: any): any {
        const ret = { x: 0, y: 0 };

        if (context.targetRotation == 0) {
            ret.x = context.screenOffsetX;
            ret.y = context.screenOffsetY;
        }
        if (context.targetRotation == 1) {
            ret.x = context.screenOffsetX;
            ret.y = - context.screenOffsetY - context.skinScreenHeight;
        }
        if (context.targetRotation == 2) {
            ret.x = -context.screenOffsetX - context.skinScreenWidth;
            ret.y = -context.screenOffsetY - context.skinScreenHeight;
        }
        if (context.targetRotation == 3) {
            ret.x = -context.screenOffsetX - context.skinScreenWidth;
            ret.y = context.screenOffsetY;
        }

        return ret;
    };

    static applyRotation(element: ElementRect, w: number, h: number, rotation: number): void {
        const t = element.top;
        const l = element.left;
        const b = element.bottom;
        const r = element.right;
        switch (rotation) {
            case 0:
                break;
            case 2:
                element.top = h - b;
                element.left = w - r;
                element.bottom = h - t;
                element.right = w - l;
                break;
            case 3:
                element.top = l;
                element.left = h - b;
                element.bottom = r;
                element.right = h - t;
                break;
            case 1:
                element.top = w - r;
                element.left = t;
                element.bottom = w - l;
                element.right = b;
                break;
        }
    };

    static isEven(value: number): boolean { return value % 2 === 0; };

    static isOdd(value: number): boolean { return value % 2 !== 0; };
};
